import React from "react";
import DataTable from "react-data-table-component";

function DataTableComponent({
  title,
  columns,
  data,
  pagination,
  subHeader,
  onRowClicked,
  Clicked,
  pointerOnHover,
  resetPaginationToggle,
  subHeaderComponentMemo,
  customStyles,
}) {
  return (
    <DataTable
      title={title}
      columns={columns}
      data={data}
      highlightOnHover={true}
      pagination={pagination}
      paginationResetDefaultPage={resetPaginationToggle}
      subHeader={subHeader}
      subHeaderComponent={subHeaderComponentMemo}
      onRowClicked={onRowClicked}
      pointerOnHover={pointerOnHover}
      Clicked={Clicked}
      customStyles={customStyles}
    />
  );
}

export default DataTableComponent;
